import type { HierarchyLevel, LevelTypography } from "../Types/types";

export const pxToRem = (px: number): string => `${px / 16}rem`;

export const DEFAULT_INFO_NOTE =
  "*CM-1 (Previous Period) represents the immediately preceding equivalent period to the selected period.";

export const hierarchyTableColors = {
  headerBg: "#ECEFF3",
  billedHoursHeaderBg: "#ECECEC",
  billedHoursPeriodHeaderBg: "#E5E5E5",
  rowBg: "#F5F5F5",
  hierarchyCellBg: "#FFFFFF",
  childHierarchyCellBg: "#FCFCFC",
  border: "#DADADA",
  borderBottom: "#F0F0F0",
  borderBilledHours: "#FFECEC",
  textPrimary: "#343A40",
  textDataChild: "#3E3F3F",
  textSecondary: "#71767A",
  textLink: "#008DF9",
  expandIcon: "#76A4FD",
  offshoreBg: "#CECECE",
  onsiteBg: "#DBDBDB",
  totalBg: "#F0F0F0",
  billedHoursRowTint: "rgba(251, 248, 248, 0.2)",
  infoSectionBg: "#EDEDED",
} as const;

export const hierarchyTableLayout = {
  hierarchyColWidth: pxToRem(200),
  revenueColWidth: pxToRem(160),
  billedHoursSubColWidth: pxToRem(120),
  hierarchyIndentBase: 12,
  hierarchyIndentStep: 11,
  headerFirstRowHeight: pxToRem(68),
  headerSecondRowHeight: pxToRem(32),
  tableMinWidth: pxToRem(1294),
  expandIconSize: pxToRem(14),
  expandIconPlaceholderWidth: pxToRem(14),
  hierarchyLabelMinHeight: pxToRem(20),
  borderThin: pxToRem(0.5),
  borderDefault: pxToRem(1),
  borderRadiusSm: pxToRem(4),
  borderRadiusMd: pxToRem(5),
  borderRadiusLg: pxToRem(8),
} as const;

export const hierarchyTableZIndex = {
  bodyStickyCell: 1,
  totalStickyCell: 2,
  headerCell: 3,
  headerStickyCorner: 6,
} as const;

export const levelTypography: Record<HierarchyLevel, LevelTypography> = {
  organization: {
    fontSize: pxToRem(16),
    fontWeight: 500,
    color: hierarchyTableColors.textPrimary,
  },
  combined_business_unit: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: hierarchyTableColors.textLink,
  },
  business_unit: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: hierarchyTableColors.textLink,
  },
  customer_group: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: hierarchyTableColors.textLink,
  },
  customer: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: hierarchyTableColors.textLink,
  },
  project: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: hierarchyTableColors.textLink,
  },
};

export const billedHoursVariantLabels = {
  offshore: "Offshore",
  onsite: "Onsite",
  total: "Total",
} as const;
